import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Btn, Input, Field } from "@/components/ui-kit";
import { AuthShell, Notice } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setMsg({ tone: "ok", text: data.message });
    } catch (err) {
      setMsg({ tone: "err", text: apiError(err.response?.data?.detail) });
    }
    setBusy(false);
  };

  return (
    <AuthShell title="Forgot Password" subtitle="We'll email you a link to choose a new password.">
      <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
        <Field label="Email" required>
          <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </Field>
        <Btn type="submit" size="lg" className="w-full" disabled={busy} data-testid="forgot-submit">
          {busy ? "Sending…" : "Send reset link"}
        </Btn>
      </form>
      {msg && <Notice tone={msg.tone} data-testid="forgot-message">{msg.text}</Notice>}
    </AuthShell>
  );
}
